import { useMemo } from 'react';

export default function useStatisticsReportStats({
  avgAttendance,
  filteredStudents,
  financeStats,
  longTermAbsentees,
  visitationStats,
}) {
  return useMemo(() => ({
    studentCount: filteredStudents.length,
    studentDelta: 2, // Mock from earlier logic
    attendanceRate: avgAttendance.current,
    attendanceDelta: avgAttendance.delta,
    visitationCount: visitationStats.count,
    visitationRate: visitationStats.rate,
    visitationDelta: visitationStats.delta,
    financeBalance: financeStats.balance,
    financeDelta: financeStats.delta,
    absentees: longTermAbsentees
  }), [
    avgAttendance.current,
    avgAttendance.delta,
    filteredStudents.length,
    financeStats.balance,
    financeStats.delta,
    longTermAbsentees,
    visitationStats.count,
    visitationStats.rate,
    visitationStats.delta,
  ]);
}
